import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import HeaderAbout from './componet/HeaderAbout';
import Footer from './componet/Footer';
import AboutContent from './componet/AboutContent';

const About = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // URL 쿼리 매개변수에서 언어 상태를 가져옵니다.
  const query = new URLSearchParams(location.search);
  const initialLanguage = query.get('lang') || 'en';

  const [language, setLanguage] = useState(initialLanguage);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    // URL 쿼리 매개변수를 업데이트합니다.
    query.set('lang', lang);
    navigate({ search: query.toString() });
  };

  useEffect(() => {
    setLanguage(initialLanguage);
  }, [initialLanguage]);

  return (
    <div className="container">
      <HeaderAbout onLanguageChange={handleLanguageChange} language={language} />
      <AboutContent language={language} />
      <Footer />
    </div>
  );
}

export default About;